export const execute500Handler = error => ({
  type: 'SET_ERROR_500',
  error,
});

export const execute403Handler = error => ({
  type: 'SET_ERROR_403',
  error,
});

export const execute400Handler = error => ({
  type: 'SET_ERROR_400',
  error,
});

export const clearErrorMessage = () => ({
  type: 'CLEAR_ERROR_MESSAGE',
  error: '',
});

export const setNotification = message => ({
  type: 'SET_NOTIFICATION',
  message,
});
